import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { useCallback, useEffect, useState } from 'react';

interface BannerSlide {
  id: number;
  type: 'default' | 'category';
  title: string;
  description: string;
  backgroundImage: string;
  category?: {
    name: string;
    icon: string;
  } | null;
}

const bannerSlides: BannerSlide[] = [
  {
    id: 1,
    type: 'default',
    title: '¡Clases nuevas todas las semanas!',
    description: 'Prueba diferentes experiencias virtuales con los mejores centros y coaches de Latinoamérica.',
    backgroundImage: 'https://cache.beholos.com/img/fitness-pass-v2/online-classes/banner-online-web005-new.webp',
    category: null
  },
  {
    id: 2,
    type: 'category',
    title: 'move',
    description: 'Desde cycling hasta entrenamiento funcional y de fuerza con y sin implementos para principiantes, intermedios y avanzados.',
    backgroundImage: 'https://image.beholos.com/fit-in/2200x1100/filters:quality(90)/img/fitness-pass-v2/online-classes/move-banner.jpg',
    category: {
      name: 'move',
      icon: 'https://cache.beholos.com/img/fitness-pass-v2/corporate/saas-cat-move.svg'
    }
  },
  {
    id: 3,
    type: 'category',
    title: 'eat',
    description: 'Aprende sobre nutrición y el arte de comer, con charlas de alimentación consciente hasta sobre cómo leer una etiqueta nutricional.',
    backgroundImage: 'https://image.beholos.com/fit-in/2200x1100/filters:quality(90)/img/fitness-pass-v2/online-classes/eat-banner.jpg',
    category: {
      name: 'eat',
      icon: 'https://cache.beholos.com/img/fitness-pass-v2/corporate/saas-cat-eat.svg'
    }
  },
  {
    id: 4,
    type: 'category',
    title: 'play',
    description: 'Actividades de entretenimiento que puedes disfrutar junto a tu familia, tus hijos y tus mejores amigos.',
    backgroundImage: 'https://image.beholos.com/fit-in/2200x1100/filters:quality(90)/img/fitness-pass-v2/online-classes/play-banner.jpg',
    category: {
      name: 'play',
      icon: 'https://cache.beholos.com/img/fitness-pass-v2/corporate/saas-cat-play.svg'
    }
  },
  {
    id: 5,
    type: 'category',
    title: 'relax',
    description: 'Desde yoga, meditación, pausas activas hasta una biblioteca de sonidos relajantes para disminuir el estrés.',
    backgroundImage: 'https://image.beholos.com/fit-in/2200x1100/filters:quality(90)/img/fitness-pass-v2/online-classes/relax-banner.jpg',
    category: {
      name: 'relax',
      icon: 'https://cache.beholos.com/img/fitness-pass-v2/corporate/saas-cat-relax.svg'
    }
  },
  {
    id: 6,
    type: 'category',
    title: 'prosper',
    description: 'Aprende con charlas de liderazgo, amor propio, crecimiento personal, salud mental y bienestar emocional.',
    backgroundImage: 'https://image.beholos.com/fit-in/2200x1100/filters:quality(90)/img/fitness-pass-v2/online-classes/prosper-banner.jpg',
    category: {
      name: 'prosper',
      icon: 'https://cache.beholos.com/img/fitness-pass-v2/corporate/saas-cat-prosper.svg'
    }
  }
];

export const Banners = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true },
    [Autoplay({ delay: 4000, stopOnInteraction: false })]
  )
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([])

  const onSelect = useCallback(() => {
    if (!emblaApi) return
    setSelectedIndex(emblaApi.selectedScrollSnap())
  }, [emblaApi])

  useEffect(() => {
    if (!emblaApi) return
    setScrollSnaps(emblaApi.scrollSnapList())
    emblaApi.on('select', onSelect)
    onSelect()
  }, [emblaApi, onSelect])

  return (
    <div className="overflow-hidden relative" ref={emblaRef}>
      <div className="flex">
        {bannerSlides.map((slide, index) => (
          <div
            key={index}
            className="min-w-full relative h-[320px] md:h-[525px] bg-no-repeat bg-cover bg-gray-100"
            style={{ ...slide.type !== 'default' && { backgroundImage: `url('${slide.backgroundImage}')` } }}
          >
            {slide.type !== 'default' && <div className="absolute inset-0 bg-black/10 z-0" />}

            <div className="relative z-10 flex items-center h-full px-8">
              <div
                className={`space-y-4 max-w-${slide.type === 'default' ? '3xl' : 'lg'} ${slide.type === 'default' ? 'mx-auto' : ''}`}>
                {slide.type === 'default' ? (
                  <div className='flex justify-between items-center'>
                    <div className='max-w-[600px]'>
                      <div className="text-black text-2xl md:text-3xl font-bold mb-4">
                        {slide.title}
                      </div>
                      <div className="w-60 mb-2 border-t-2 border-black"></div>
                      <div className="text-black text-base md:text-xl">
                        {slide.description}
                      </div>
                    </div>
                    <img src={slide.backgroundImage} alt="Banner" className="hidden md:block ml-8 w-150 h-auto object-contain" />
                  </div>
                ) : (
                  <>
                    <div
                      className={`saas-tag saas-category-label-video banner mb-3 inline-block px-3 ${slide.category?.name ? `bg-${slide.category.name}` : ''}`}
                      style={{ borderRadius: "25px" }}
                    >
                      <div className="flex items-center p-2">
                        <div className="text-xl font-medium uppercase mr-2 text-black">
                          {slide.category?.name}
                        </div>
                        <img
                          src={slide.category?.icon}
                          alt={slide.category?.name || "icon"}
                          className="h-6"
                        />
                      </div>
                    </div>
                    <div className="w-60 mb-2 border-t-2 border-white"></div>
                    <div className="text-black text-sm md:text-lg max-w-[300px]">
                      {slide.description}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {scrollSnaps.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${index === selectedIndex ? 'bg-holos-dark' : 'bg-gray-400'
              }`}
            onClick={() => emblaApi?.scrollTo(index)}
          />
        ))}
      </div>
    </div>
  )
}